// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CountryDataItem  {
    _originalTypeClassName = "Loom.BO.CountryDataItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CountryDataItem.translate = translateService;
}
this.name = null;
this.dial_code = null;
this.code = null;
this.timezones = null;
this.lat = null;
this.longt = null;
this.CountryDataItemKey = null;
this._key = this.CountryDataItemKey = 0; 
}

static translate: TranslateService;
_key: any;
name:any;
dial_code:any;
code:any;
timezones:any;
lat:any;
longt:any;
private _CountryDataItemKey:any;
get CountryDataItemKey(): any {
    return this._CountryDataItemKey;
  }
set CountryDataItemKey(value: any) {
    this._CountryDataItemKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CountryDataItemKey == null || $this.CountryDataItemKey == 0;
            }


}